import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const CriticalMineralsDashboard = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the new overview page
    navigate('/overview', { replace: true });
  }, [navigate]);

    return (
    <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center">
                        <div className="text-center">
        <div className="text-2xl mb-4">🔄</div>
        <div className="text-xl">Redirecting to Critical Minerals Dashboard...</div>
                             </div>
                           </div>
                         );
};

export default CriticalMineralsDashboard;